<template>
  <ReactPage>
    <game-daily-play-report-page></game-daily-play-report-page>
  </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
  name: "GameDailyPlayReport",
  components: {
    ReactPage
  }
}
</script>